import BaseApp from './BaseApp';
import TrustUpIOTaskEndpoint from './endpoints/TrustUpIOTaskEndpoint';
import WebsocketListener from './WebsocketListener';
import Vue from 'vue';
import DestroyModelEventsMixin from './DestroyModelEventsMixin';

export default class TrustUpBase extends BaseApp
{

    init()
    {
        Vue.mixin(DestroyModelEventsMixin);
    }

    setup()
    {
        this.endpoints = {
            trustupIOTask: new TrustUpIOTaskEndpoint()
        };

        this.websocketListener = new WebsocketListener().init();

    }

    shouldRegisterComponents()
    {
        return false;
    }

}